export default __webpack_public_path__ + "static/media/CloseCircle.5c3b0510.svg";